/*
 * MainLayout.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 03 2023 mys Company
 */

import { Outlet } from 'react-router'
import Footer from '../../component/general/Footer'
import Header from '../../component/general/Header'
import Sidebar from './Sidebar'
import bgImage from '../../assets/images/bgMain.svg'

const MainLayout = () => {
    return (
        <div>
            <div className="h-scren bg-main ">
                <div className="h-screen">
                    <div className="grid md:grid-cols-4 lg:grid-cols-5 h-12/13 ">
                        <div className="hidden md:inline-block pl-4 md:col-span-1 overflow-y-scroll ">
                            <Sidebar />
                        </div>
                        <div className="col-span-1 md:col-span-3 lg:col-span-4 bg-no-repeat bg-left-bottom overflow-y-scroll overflow-x-hidden " style={{ backgroundImage: `url(${bgImage})` }}>
                            <Header />
                            <div className="">
                                <Outlet />
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>

        // <div>
        //   <div className="">
        //     <Header />
        //     <div className="  overflow-scroll bg-gray-50 ">
        //       <div className="hidden md:inline-block md:w-4/12  lg:w-3/12 xl:w-2/12 pl-1">
        //         <Sidebar />
        //       </div>
        //       <div className="w-full inline-block md:w-8/12 lg:w-10/12 pl-1 ">
        //         <Outlet />
        //       </div>
        //     </div>
        //     <Footer />
        //   </div>
        // </div>
    )
}

export default MainLayout
